<template>
    <div id="app">
        <router-view/>
        <div v-else>
            <loading class="app-loading" />
        </div>
        <b-modal v-model="site.isCompletarPerfilModalVisible"
            hide-footer
            hide-header-close
            :busy="true"
            centered
            title="Completar perfil"
            @hide="cerrarModal">
            <div class="text-center">
                <p>Debe completar los datos de su perfil</p>
                <button @click="irAPerfil()"
                    class="btn btn-primary">Ir a perfil
                </button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import Vue from "vue";
import VueHead from "vue-head";
import { mapState, mapGetters } from "vuex";
import Loading from "./components/Loading";
import bModal from "bootstrap-vue/es/components/modal/modal";
import bModalDirective from "bootstrap-vue/es/directives/modal/modal";

Vue.use(VueHead);

export default {
	components: { Loading, bModal },
	directives: { "b-modal": bModalDirective },
	computed: {
		...mapState(["isPortalReady", "site", "user"]),
		...mapGetters(["userActivado"])
	},
	data() {
		return {
			isCompletarPerfilModalVisible: false
		};
	},
	methods: {
		loadPortalInfo() {
			this.$store.commit("setIsLoadingPortal", true);
			this.$store
				.dispatch("getPortalInfo")
				.then(data => {
					//console.log("loadportalinfo", data);
					if (typeof localStorage !== "undefined") {
						localStorage.setItem("portal", JSON.stringify(data));
					}
					this.$store.commit("setIsLoadingPortal", false);
				})
				.catch(error => {
					this.$store.commit("setIsLoadingPortal", false);
				});
		},
		loadUserInfo() {
			this.$store.commit("setIsLoadingUser", true);
			this.$store
				.dispatch("getUserCookie")
				.then(response => {
					this.$store.commit("setIsLoadingUser", false);
					// Cargar compras de usuario
					this.loadUserCompras();
					// Cargar videos de usuario
					this.loadUserVideos();
					//console.log("ruta actual", this.$route.name);
					this.$store.dispatch("checkUserActivado", this.$route.name);
				})
				.catch(error => {
					// No hay cookie de sesión válida.
					// TODO: manejar
					this.$store.commit(
						"toggleCompletarPerfilModalVisible",
						false
					);
					this.$store.commit("setIsLoadingUser", false);
				});
		},
		loadUserCompras() {
            this.$store.commit("setIsLoadingUserCompras", true);


			this.$store
				.dispatch("getUserComprasCache")
				.then(response => {
					//console.log("getUserComprasCache", response);
					this.$store.commit("setIsLoadingUserCompras", false);
				})
				.catch(error => {
					//console.log("loadusercompras error", error);
					this.$store.commit("setIsLoadingUserCompras", false);
					// No hay cookie de sesión válida.
					// TODO: manejar
                });

			this.$store
				.dispatch("getUserCompras")
				.then(response => {
					//console.log("getusercompras", response);
					this.$store.commit("setIsLoadingUserCompras", false);
				})
				.catch(error => {
					console.log("loadusercompras error", error);
					this.$store.commit("setIsLoadingUserCompras", false);
					// No hay cookie de sesión válida.
					// TODO: manejar
                });




		},
		loadUserVideos() {
			//console.log("loadinguservideos");
			this.$store.commit("setIsLoadingUserVideos", true);
			this.$store
				.dispatch("getUserVideos")
				.then(response => {
					this.$store.commit("setIsLoadingUserVideos", false);
				})
				.catch(error => {
					this.$store.commit("setIsLoadingUserVideos", false);
					console.log("loadusercompras error", error);
					// No hay cookie de sesión válida.
					// TODO: manejar
				});
		},
		getPlayerScript() {
			this.$api
				.getPlayerEmbed("libraries", "")
				.then(response => {
					//console.log("player", response);
					if (document.querySelector("#player-script") !== null)
						document.querySelector("#player-script").remove();

					let script = document.createElement("script");
					script.src = response.data.player;
					document
						.getElementsByTagName("head")[0]
						.appendChild(script);
				})
				.catch(error => console.log(error));
		},
		loginSubmit() {},
		loggedIn() {},
		loginError() {},
		irAPerfil() {
			this.$store.commit("toggleCompletarPerfilModalVisible", false);
			this.$router.push({ name: "perfil" });
		},
		cerrarModal(e) {
			if (this.site.isCompletarPerfilModalVisible) e.preventDefault();
		}
	},
	created() {
		this.$http.defaults.headers.common["X-Requested-With"] =
			"XMLHttpRequest";

		/*// Cargar info del portal desde localStorage (si existe).
		if (typeof localStorage !== "undefined") {
			// buscar portal
			if (localStorage.getItem("portal")) {
				// Ver si el portal ya tiene id
				const portal = JSON.parse(localStorage.getItem("portal"));
				if (portal.hasOwnProperty("id"))
					this.$store.commit(
						"setPortalInfo",
						JSON.parse(localStorage.getItem("portal"))
					);
			}
		}*/

		// Actualizar info desde servidor.
		//this.loadPortalInfo();

		// Si hay un cookie de usuario, le inicio sesión.
		//this.loadUserInfo();

		// Cargar script de player
		//this.getPlayerScript();
	},
    beforeCreate(){
        if (window.location.href === "https://topclassweb.multinetlabs.com/") {
            window.location.href = "https://www.topclass.academy/"
        }
    }
};
</script>

<style lang="scss">
@import "assets/styles/main";
</style>
